import './style.css';

import { useSelector } from 'react-redux';

import { useNavigate } from 'react-router-dom';
import store from '../../store/store';
const selectWindowInnerSize = (state) => state.windowInnerSize;
const selectNavigateBackLocation = (state) => state.navigateBackLocation;

export default function CookiePolicy() {
  const windowInnerSize = useSelector(selectWindowInnerSize);
  const navigateBackLocation = useSelector(selectNavigateBackLocation);

  const navigate = useNavigate();

  return (
    <div className="CookiePolicy Page headline" style={{ height: windowInnerSize.height }}>
      <img
        src="/images/back-page.png"
        alt="Back to previous page"
        className="CookiePolicy__back-btn"
        onClick={() => {
          navigate(navigateBackLocation.page,{ state: { forceRefresh: true } });
        }}
      />
      <div
        style={{
          padding: ' 2vw 5vw 5vw',
          maxWidth: '1400px',
          margin: '0 auto',
        }}
      >
        <h1>PassionStocks – Cookie Policy</h1>
        <p>
          <span style={{ fontSize: 12 + 'pt' }}>Last Updated: January 5, 2026</span>
        </p>
        <p>
          This Cookie Policy explains how PassionStocks, Inc. (&quot;PassionStocks,&quot; &quot;we,&quot; &quot;us,&quot; or &quot;our&quot;) uses cookies and similar technologies when you visit or use our website, waitlist, platform, and related services (collectively, the &quot;Platform&quot;).
        </p>
        <h2>1. What Are Cookies?</h2>
        <p>
          Cookies are small text files placed on your device when you visit a website or use an online service. They help recognize your device, remember preferences, and improve your experience.
        </p>
        <p>
          We may also use similar technologies such as pixels, web beacons, SDKs, and local storage. For simplicity, all such technologies are referred to in this policy as &quot;Cookies.&quot;
        </p>
        <h2>2. Types of Cookies We Use</h2>
        <p>
          We use the following categories of Cookies:
        </p>
        <p>
          <span>2.1 Strictly Necessary Cookies</span>
        </p>
        <ul>
          <li>
            <p>These Cookies are required for the Platform to function properly, such as enabling login, account management, security, and payment processing.</p>
          </li>
          <li>
            <p>These Cookies cannot be disabled.</p>
          </li>
        </ul>
        <p>
          <span>2.2 Performance &amp; Analytics Cookies</span>
        </p>
        <ul>
          <li>
            <p>These Cookies collect information about how users interact with the Platform (e.g., pages visited, feature usage).</p>
          </li>
          <li>
            <p>They help us understand usage patterns and improve performance and usability.</p>
          </li>
        </ul>
        <p>
          <span>2.3 Functional Cookies</span>
        </p>
        <ul>
          <li>
            <p>These Cookies remember choices you make, such as language, region, or saved preferences, to enhance your experience.</p>
          </li>
        </ul>
        <p>
          <span>2.4 Advertising &amp; Targeting Cookies</span>
        </p>
        <ul>
          <li>
            <p>These Cookies may track browsing activity to deliver relevant content or promotions and measure effectiveness.</p>
          </li>
          <li>
            <p>We only use these Cookies with your consent, where required by applicable law.</p>
          </li>
        </ul>
        <h2>3. How We Use Cookies</h2>
        <p>We use Cookies to:</p>
        <ul>
          <li>
            <p>Enable core Platform functionality</p>
          </li>
          <li>
            <p>Keep you logged in and secure your account</p>
          </li>
          <li>
            <p>Process purchases and payments</p>
          </li>
          <li>
            <p>Display and track shoutouts</p>
          </li>
          <li>
            <p>Analyze Platform performance and usage</p>
          </li>
          <li>
            <p>Improve features and personalization</p>
          </li>
          <li>
            <p>Deliver promotions or communications (where permitted and consented to)</p>
          </li>
        </ul>
        <h2>4. Third-Party Cookies</h2>
        <p>
          Some Cookies may be placed by third parties that provide services such as analytics, payments, social media integrations, or advertising. These third parties may collect information about your online activities across websites and over time.
        </p>
        <p>
          We do not control third-party Cookies and are not responsible for their practices. Please review the applicable third-party privacy and cookie policies for more information.
        </p>
        <h2>5. Legal Basis for Cookies (GDPR / UK GDPR)</h2>
        <p>
          If you are located in the EU, EEA, or UK:
        </p>
        <ul>
          <li>
            <p>Strictly Necessary Cookies are used based on our legitimate interest in operating a secure and functional Platform.</p>
          </li>
          <li>
            <p>All other Cookies are used only with your consent, which you may withdraw at any time.</p>
          </li>
        </ul>
        <h2>6. Your Choices</h2>
        <p>
          You have the following options regarding Cookies:
        </p>
        <p>
          <span>Cookie Banner / Consent Tool</span>
        </p>
        <p>
          When you first visit the Platform, you may be presented with a cookie banner allowing you to accept or reject non-essential Cookies.
        </p>
        <p>
          <span>Browser Controls</span>
        </p>
        <p>
          You can block or delete Cookies through your browser settings. Note that disabling certain Cookies may affect Platform functionality.
        </p>
        <p>
          <span>Targeted Advertising Opt-Out</span>
        </p>
        <p>
          You may opt out of interest-based advertising through industry tools such as:
        </p>
        <ul>
          <li>
            <p>Network Advertising Initiative</p>
          </li>
          <li>
            <p>YourAdChoices</p>
          </li>
          <li>
            <p>Your Online Choices (EU)</p>
          </li>
        </ul>
        <h2>7. Cookie Retention</h2>
        <p>Cookies may remain on your device for different periods:</p>
        <ul>
          <li>
            <p>Session Cookies are deleted when you close your browser.</p>
          </li>
          <li>
            <p>Persistent Cookies remain until they expire or are deleted through your browser settings.</p>
          </li>
        </ul>
        <h2>8. Changes to This Cookie Policy</h2>
        <p>
          We may update this Cookie Policy from time to time. Any changes will be posted on the Platform, and the &quot;Last Updated&quot; date will be revised accordingly.
        </p>
        <h2>9. Contact Us</h2>
        <p>
          If you have questions or concerns about this Cookie Policy, please contact us at:
        </p>
        <p>
          PassionStocks Inc. Business address: 149 Commonwealth Drive, Menlo Park, California 94025, United States, Email Address: privacy.passionstocks@hey.com
        </p>
      </div>
    </div>
  );
}

